export const HOUSE_AUCTION_CREATE_PAGE_PATH = '/auction/house/create'

export const HOUSE_AUCTION_LIST_PAGE_PATH = '/auction/house/list'
